import BaseContent from "./BaseContent";

export default BaseContent;
